import React from 'react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import TextField from '@material-ui/core/TextField';
import { Grid, Button } from 'semantic-ui-react';

class Edit extends React.Component {

  state = {
    brand_name: this.props.brand_name,
    id: this.props.id,
    load: false,
    message: '',
    data: this.props.data,
  }

  onChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  update() {
    let context = this;
    let brand_name = this.state.brand_name;
    let id = this.state.id;
    let oldData = this.state.data;
    if (brand_name == '' || brand_name == null || brand_name == undefined) {
      this.setState({
        error: 'Enter Brand Name!!!'
      });
    }
    let data1 = { 'brand_name': brand_name, 'id': id };

    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'addmenu/branddetails/update.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });

        if (data == 1) {
          for (var i = 0; i < oldData.length; i++) {
            if (id == oldData[i].id) {
              oldData[i].brand_name = brand_name;
            }
          }
          context.props.updateData(oldData);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  render() {
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <form noValidate autoComplete="off">
              <TextField
                id="outlined-name"  label="Brand Name"
                value={this.state.brand_name} fullWidth
                onChange={this.onChange('brand_name')}
                margin="normal" variant="outlined" />
            </form>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <center><div style={{color: 'red'}}>{this.state.error}</div></center>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={ () => { this.props.handleClose(); } }>Cancel</Button>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={8}>
            <Button fluid onClick={this.update.bind(this)}>Save</Button>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default Edit;
